
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { NavBar, LineChart, BarChart, CreateUpdateApiModal, ApiCard } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

@Component({
  components: {
    NavBar,
    CreateUpdateApiModal,
    ApiCard
  }
})

export default class StudentsApiView extends Vue {
  data () {
    return {
      isLoading: false,
      selectedUserId: null,
      // users: [],
      apis: [],
      isApiModalOpen: false,
      isCreate: true,
      idx: -1,
      activeKey: '',
      externalType: null,
      loggedUserId: null
    }
  }

  mounted () {
    this.loggedUserId = store.getters.getLoggedUserId
    // this.getUsers()
    this.selectedUserId = this.$store.getters.getSelectedUserId
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  updateSelectedUserId () {
    this.selectedUserId = this.$store.getters.getSelectedUserId
    this.loadUserApis()
  }

  openNewApiModal () {
    this.activeKey = ''
    this.idx = -1
    this.isCreate = true
    this.externalType = null
    this.openCreateUpdateApiModal()
  }

  openUpdateApiModal (obj: { idx: number, type: string, key: string }) {
    this.activeKey = obj.key
    this.idx = obj.idx
    this.isCreate = false
    this.externalType = obj.type
    this.openCreateUpdateApiModal()
  }

  openDeleteDialog (obj: { idx: number, type: string }) {
    this.$buefy.dialog.confirm({
      title: 'Delete',
      message: 'Are you sure to delete api key? You won\'t be able to recover it.',
      onConfirm: () => {
        this.deleteApi(obj.idx, obj.type)
      },
      canCancel: false
    })
  }

  async openCreateUpdateApiModal () {
    this.isApiModalOpen = true
  }

  async loadUserApis () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getApis/${this.selectedUserId}`))
      this.apis = resp
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Apis info.',
        canCancel: false
      })
    }
  }

  /* async getUsers () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUsers`))
      this.users = resp.filter(e => e.id !== this.loggedUserId)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Users.',
        canCancel: false
      })
    }
  } */

  async deleteApi (idx: number, type: string) {
    try {
      this.isLoading = true

      var resp
      var data = {
        type: type.toLowerCase(),
        userId: this.selectedUserId,
        idx
      }
      resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/deleteApiKey`, data)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Api deleted successfully',
          onConfirm: this.loadUserApis,
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
